/**
 * mainPagesPopulateHeader.ts
 * 
 * Javascript for body_section_start_include_every_page.jsp page section  
 * 
 * page variable: mainPagesPopulateHeader
 * 
 * 
 */

//////////////////////////////////
// JavaScript directive:   all variables have to be declared with "var", maybe other things
"use strict";

///////////////////////////////////////////

/**
 * 
 */
export class MainPagesPopulateHeader {

	private _initializeCalled = false

	/**
	 * 
	 */
	constructor(  ) {
		
	};
		
	/**
	 * initialize the page - does NOTHING
	 */
	initialize(  ) {

		this._initializeCalled = true;
	};

};

